import template from './analytics-bot.html';
import controller from './analytics-bot.controller';
import './analytics-bot.styl';

let analyticsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default analyticsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-bot/analytics-bot.component.js
 **/